import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchWrapper } from '_helpers';

const name = 'filters';
const initialState = createInitialState();
const extraActions = createExtraActions();
const reducers = createReducers();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, reducers, extraReducers });

// exports
export const filterActions = { ...slice.actions, ...extraActions };
export const filtersReducer = slice.reducer;

// implementation
function createInitialState() {
    return {
        list: null,
        item: null,
        values: null,
        isLoading: false,
    };
}

function createReducers() {
    return {
        setFilter,
        clearFilter
    };

    function setFilter(state, action) {
        state.item = action.payload;
    }

    function clearFilter(state){
        state.item = null;
    }
}

function createExtraActions() {
    const baseUrl = process.env.REACT_APP_API_URL;

    return {
        getFilterValues: getFilterValues(),
        getAllFilters: getAllFilters(),
        createFilter: createFilter(),
        updateFilter: updateFilter(),
        deleteFilter: _deleteFilter(),
    };

    function getFilterValues() {
        return createAsyncThunk(
            `${name}/getValues`,
            async () => await fetchWrapper.get(`${baseUrl}/filters_values`)
        );
    }

    function getAllFilters() {
        return createAsyncThunk(
            `${name}/getAll`,
            async () => await fetchWrapper.get(`${baseUrl}/filters`)
        );
    }

    function createFilter() {
        return createAsyncThunk(
            `${name}/create`,
            async (filter) => await fetchWrapper.post(`${baseUrl}/filter`, filter)
        );
    }

    function updateFilter() {
        return createAsyncThunk(
            `${name}/update`,
            async function({ filterid, filter }) {
                await fetchWrapper.put(`${baseUrl}/filter/${filterid}`, filter);
            }
        );
    }

    function _deleteFilter() {
        return createAsyncThunk(
            `${name}/delete`,
            async (id) => {
                await fetchWrapper.delete(`${baseUrl}/filter/${id}`);
                return id;
            }
        );
    }
}

function createExtraReducers() {
    return (builder) => {
        getFilterValues();
        getAllFilters();
        _deleteFilter();
        createFilter();
        updateFilter();

        function handlePending(state) {
            state.pendingCount = (state.pendingCount || 0) + 1;
            state.isLoading = true;
        }

        function handleFulfilled(state, action, field = 'list', updateState = true) {
            state.pendingCount = (state.pendingCount || 0) - 1;
            
            if (updateState) {
                state[field] = action.payload;
            }
            if (state.pendingCount === 0) {
                state.isLoading = false;
            }
        }

        function handleRejected(state, action) {
            state.pendingCount = (state.pendingCount || 0) - 1;
            state.error = action.error.message || 'Echec de récupération des évènements';
            if (state.pendingCount === 0) {
                state.isLoading = false;
            }
        }

        function getFilterValues() {
            const { pending, fulfilled, rejected } = extraActions.getFilterValues;
            builder
                .addCase(pending, handlePending)
                .addCase(fulfilled, (state, action) => handleFulfilled(state, action, 'values', true))
                .addCase(rejected, handleRejected);
        }

        function getAllFilters() {
            const { pending, fulfilled, rejected } = extraActions.getAllFilters;
            builder
                .addCase(pending, handlePending)
                .addCase(fulfilled, (state, action) => handleFulfilled(state, action, 'list', true))
                .addCase(rejected, handleRejected);
        }

        function createFilter() {
            const { pending, fulfilled, rejected } = extraActions.createFilter;
            builder
                .addCase(pending, handlePending)
                .addCase(fulfilled, (state, action) => handleFulfilled(state, action, 'data', false))
                .addCase(rejected, handleRejected);
        }

        function updateFilter() {
            const { pending, fulfilled, rejected } = extraActions.updateFilter;
            builder
                .addCase(pending, handlePending)
                .addCase(fulfilled, (state, action) => handleFulfilled(state, action, 'data', false))
                .addCase(rejected, handleRejected);
        }

        function _deleteFilter() {
            const { pending, fulfilled, rejected } = extraActions.deleteFilter;
            builder
                .addCase(pending, handlePending)
                .addCase(fulfilled, (state, action) => handleFulfilled(state, action, 'data', false))
                .addCase(rejected, handleRejected);
        }
    };
}


export default filtersReducer;

